import "./LandingPage.css";

const Impressum = () => {
  return (
    <div className="impressum-page">
      <div className="impressum-inner">
        <a href="/" className="impressum-back">← Back to AgentCRM</a>
        <h1>Impressum</h1>
        <p className="impressum-placeholder">
          This page is a placeholder. Full legal/company details (entity name, address, registration
          and contact information as required by law) will be added here before public launch.
        </p>
      </div>
    </div>
  );
};

export default Impressum;
